<template>
  <v-row no-gutters class="pt-4">
    <v-col lg="4" md="6" sm="6">
      <v-text-field
        v-model="cepCliente"
        label="digite o CEP"
        hide-details="auto"
        v-mask="mask.cep"
        color="var(--vs-azul-secundaria)"
      ></v-text-field>
    </v-col>

    <v-col lg="8" md="6" sm="6">
      <vs-button color="#43A047" @click="calculaFrete" border>
        <i class="las la-shipping-fast pr-2" style="font-size: 16px !important"></i>
        <template>Calcular frete</template>
      </vs-button>
    </v-col>

    <v-row no-gutters>
      <v-layout>
        <div v-if="valorFrete !== true ">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon color="var(--vs-vermelho)" v-on="on" @click="limparFrete">
                <v-icon>las la-times</v-icon>
              </v-btn>
            </template>
            <span>Limpar cálculo de frete</span>
          </v-tooltip>
        </div>


        <div v-if="valorFrete !== true">
          <v-row no-gutters>
            <v-layout>
              <i class="las la-map-marker pt-1" style="font-size: 28px !important"></i>

              <v-col lg="8" class="pa-0 ma-0">
                <span class="font-weight-light grey--text text--darken-2 body-2" v-if="cepFrete">
                  {{ cepFrete.logradouro }} -
                  {{ cepFrete.bairro }}
                  CEP {{ cepFrete.cep }}
                </span>
                <p class="font-weight-bold" v-if="valorFrete === retornoValorFreteNull" >{{valorFrete}}</p>
                <p class="font-weight-bold" v-else-if="valorFrete == retornoValorFreteZero" >FRETE GRÁTIS</p>
                <p class="font-weight-bold" v-else-if="valorFrete === false"></p>
                <p class="font-weight-bold" v-else>{{parseFloat(valorFrete).toFixed(2).replace('.', ',') | currency}}</p>
              </v-col>
            </v-layout>
          </v-row>
        </div>
      </v-layout>
    </v-row>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import Alert from "../utils/alert";

export default {
  directives: {
    mask,
  },
  props: ["pecaFrete"],
  data() {
    return {
      mask: {
        creditCard: "#### #### #### ####",
        fone: "(##) #####-####",
        cnpj: "##.###.###/####-##",
        cep: "#####-###",
      },
      cepCliente: null,
      retornoValorFreteNull:
        "Não há uma tabela de valores de frete para sua região! Favor entrar em contato com a concessionária via chat.",
      retornoValorFreteZero: "0",
    };
  },
  methods: {
    calculaFrete() {
      let valorACalcular;
      if (this.totalPedio() !== 0) {
        valorACalcular = this.totalPedio();
      } else {
        valorACalcular = this.pecaFrete.ancFltPrecoVendaDesconto;
      }

      if (this.cepCliente === null) {
        Alert.warn("", "Favor informar o seu CEP.");
      } else if (this.cepCliente.length < 9) {
        Alert.warn("", "Favor verificar se o seu CEP está correto.");
      } else {
        this.$store.commit("pedido/setValorFrete", false);
        if ( this.user && this.user.cliIntCod && this.cepCliente !== null && this.cepCliente.length === 9 ) {
          this.$store.dispatch("pedido/calcularFrete", {
            cep: this.cepCliente,
            cliIntCod: this.user.cliIntCod,
            empIntCod: this.empresa.empIntCod,
            valor: valorACalcular,
          });
        } else {
          if (this.cepCliente !== null && this.cepCliente.length === 9) {
            this.$store.dispatch("pedido/calcularFrete", {
              cep: this.cepCliente,
              cliIntCod: -1,
              empIntCod: this.empresa.empIntCod,
              valor: valorACalcular,
            });
          }
        }
      }
      if (this.cepCliente !== null && this.cepCliente.length === 9) {
        this.$store.dispatch(
          "cliente/procurarCEPFrete",
          this.cepCliente.replace(".", "").replace("-", "")
        );
      }
      this.cepCliente = null;
    },
    limparFrete() {
      this.$store.commit("cliente/setEnderecoFrete", null);
      this.$store.commit("pedido/setValorFrete", true);
      this.cepCliente = "";
      this.$store.dispatch("pedido/totalPedidoSemFrete");
      this.$store.dispatch("pedido/totalPedidoComFrete");
    },
    totalPedio() {
      let total;
      if (this.carrinho.length > 0) {
        total = this.carrinho
          .map((item) => item.anuncio.ancFltPrecoVendaDesconto * item.carIntQtd)
          .reduce((a, v) => a + v);
        // console.log(total);
      } else {
        total = 0;
      }
      return total;
    },
  },
  computed: {
    ...mapGetters({
      user: "cliente/user",
      empresa: "anuncio/empresa",
      valorFrete: "pedido/valorFrete",
      cepFrete: "cliente/cepFrete",
      carrinho: "pedido/carrinho",
    }),
  },
  created() {},
};
</script>

<style scoped>
</style>
